import React, { useCallback } from "react";
import Particles, { ParticlesProvider } from "@tsparticles/react";
import { loadFireworksPreset } from "@tsparticles/preset-fireworks";
import type { Engine } from "@tsparticles/engine";

const FireworksEffect: React.FC = () => {
    const particlesInit = useCallback(async (Engine : Engine) => {
        await loadFireworksPreset(Engine);
    }, []);
    
    const particlesLoaded = useCallback(async () => {
        // Select the canvas wrapper and apply styles
        const element = document.getElementsByClassName("ParticlesCanvasWrapper")[0] as HTMLElement;
        if (element) {
            element.style.backgroundColor = "white"; // Apply white background
            element.style.pointerEvents = "none"; // Prevent interaction
        }
    }, []);

    return (
        <ParticlesProvider init={particlesInit}>
            <Particles
                id="tsparticles"
                particlesLoaded={particlesLoaded}
                className="ParticlesCanvasWrapper"
                options={{
                preset: "fireworks",
                fpsLimit: 30, // Limit FPS for better performance
                retina_detect: false, // Disable retina rendering
                background: {
                    color: {
                        value: "#ffffff", // Force white background for canvas
                    },
                },
                fireworks: {
                    explosions: 1, // Only one explosion at a time
                    particles: 50, // Number of particles per explosion
                },
                particles: {
                    number: {
                        value: 0, // No continuous particles; handled by fireworks settings
                    },
                },
                emitters: {
                    life: {
                        duration: 0.5, // Each firework lasts for 0.5 seconds
                        count: 0, // Infinite emissions
                    },
                    rate: {
                        quantity: 2, // Emit one firework at a time
                        delay: 1.5, // Delay of 1.5 seconds between each firework
                    },
                    position: {
                        x: 50, // Center horizontally (50% of screen width)
                        y: 50, // Center vertically (50% of screen height)
                    },
                },
                }}
            />
        </ParticlesProvider>
    );
};

export default FireworksEffect;
